import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=3dbe3160"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"
import style0 from "./Comments.vue?vue&type=style&index=0&id=3dbe3160&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dbe3160')) {
      api.createRecord('3dbe3160', component.options)
    } else {
      api.reload('3dbe3160', component.options)
    }
    module.hot.accept("./Comments.vue?vue&type=template&id=3dbe3160", function () {
      api.rerender('3dbe3160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Loads/Comments.vue"
export default component.exports